import React from 'react';

const cellStyle = {
  fontSize: '24px',
  height: '75px',
  width: '75px',
  padding: 'auto',
};

// eslint-disable-next-line @typescript-eslint/no-empty-function
function BlockCell({ cellId, onClick = () => {}, isActive, content = '' }) {
  const handleClick = () => onClick(cellId);
  return (
    <div
      id={cellId}
      className="d-flex flex-column border border-color-primary justify-content-center align-items-center"
      style={{ ...cellStyle, background: isActive[cellId] ? '#5cbfe6' : '' }}
      onClick={handleClick}
    >
      {content[cellId]}
    </div>
  );
}

export default BlockCell;
